import { graphql } from '@generated/gql';

export const DASHBOARD_GLOBAL_FILTER_FIELDS = graphql(/** GraphQL */ `
  fragment DashboardGlobalFilterFields on DashboardGlobalFilter {
    reportType
    field
    comparison
    value
  }
`);

export const DASHBOARD_WIDGET_FIELDS = graphql(/** GraphQL */ `
  fragment DashboardWidgetFields on Widget {
    type
    columns
    filters {
      comparison
      field
      value
    }
    format
    grouping {
      field
      interval
      type
      valueAggregation
      valueField
    }
    height
    width
    x
    y
    reportType
    sortDesc
    sortField
    translatedTitle {
      en
      fr
      es
    }
  }
`);

export const FETCH_DASHBOARD = graphql(/** GraphQL */ `
  query dashboardFetchOrganizationDashboard($dashboardId: ObjectID!) {
    fetchOrganizationDashboard(dashboardId: $dashboardId) {
      dashboard {
        id
        organization {
          id
        }
        translatedName {
          en
          fr
          es
        }
        globalFilters {
          ...DashboardGlobalFilterFields
        }
        widgets {
          ...DashboardWidgetFields
        }
      }
    }
  }
`);

export const FETCH_DASHBOARD_NAME = graphql(/** GraphQL */ `
  query dashboardFetchOrganizationDashboardName($dashboardId: ObjectID!) {
    fetchOrganizationDashboard(dashboardId: $dashboardId) {
      dashboard {
        id
        translatedName {
          en
          fr
          es
        }
      }
    }
  }
`);

export const UPDATE_DASHBOARD = graphql(/** GraphQL */ `
  mutation dashboardUpdateOrganizationDashboard(
    $input: UpdateOrganizationDashboardInput!
  ) {
    updateOrganizationDashboard(input: $input) {
      dashboard {
        id
        translatedName {
          en
          fr
          es
        }
      }
    }
  }
`);

export const FETCH_REPORT_OPTIONS = graphql(/** GraphQL */ `
  query dashboardFetchReportOptions($input: FetchReportOptionsInput!) {
    fetchReportOptions(input: $input) {
      filters {
        field
        comparisons {
          comparison
          valueTypes
          options
        }
      }
      columns
    }
  }
`);

export const GENERATE_REPORT = graphql(/** GraphQL */ `
  query dashboardGenerateReport($input: GenerateReportInput!) {
    generateReport(input: $input) {
      grouping
      data
      columns
      totalCount
    }
  }
`);
